$('body').on('submit','[name=formContato]', function() {
	try	{
		var $self = $(this);

		if ($self.data('enviando')) return false;
		if (!$self.find('.required').validate()) return false;

		$self.data('enviando',true);
		$.fancybox.showLoading();

		grecaptcha.ready(function () {
			grecaptcha.execute(window.recaptcha_site_key, { action: 'submit' }).then(function (token) {
				$self.find('[name=recaptcha_token]').remove();
				$self.append('<input type="hidden" name="recaptcha_token" value="' + token + '">');
				
				var callback = function(resp) {
					if (undefined != resp.redirect_url) {
						location.href = resp.redirect_url;
						return;
					}

					$.fancybox.hideLoading();
					$self.data('enviando',false);

					if (undefined != resp.popup_url) {
						$.fancybox.open([{
							href: resp.popup_url,
							type: 'ajax'
						}],{});
						return;
					}

					alert(resp.msg);

					if (resp.success) {
						$self.find(':text,textarea,select').val('');
					}
				};

				$.ajax({
					url: $self.attr('action'),
					type: 'post',
					dataType: 'json',
					data: $self.serializeArray(),
					success: callback,
					error: function() {
						callback({
							success: false,
							msg: "Não foi possível enviar o formulário."
						});
					}
				});
			}); 
		});

	} catch (e) {
		console.log(e);
	}

	return false;
});


//////////////////
// WEBPACK FOOTER
// ../src/contato/index.js
// module id = 69
// module chunks = 0